import { createSelector } from "reselect";

import Store, { RootState } from "../../../redux/store";
import { WorkOrdersState } from "../../../redux/reducers/workOrdersReducer";
import { ApprovalStatus } from "../../../types/approval-status/approval-status.type";

import * as actions from "./work-order.actions";

export const getWorkOrderState = (state: RootState) => state.workOrders;

export const getWorkOrder = createSelector(
  getWorkOrderState,
  (state: WorkOrdersState) => state.data
);

export function updateStatus(status: ApprovalStatus) {
  Store.dispatch(actions.updateStatus(status));
}
